// import React, { useCallback, useEffect, useMemo, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { vendorApi } from "../../services/vendorApi";
// import { useVendorAuth } from "../../store/vendorAuthStore";
// import { OrderTimer } from "../../components/OrderTimer";

// /* ── helpers ── */
// function toDateOnly(d) { return d ? String(d).slice(0, 10) : ""; }
// function inDateRange(orderDate, from, to) {
//   const od = toDateOnly(orderDate);
//   if (!od) return true;
//   if (from && od < from) return false;
//   if (to && od > to) return false;
//   return true;
// }
// function dateFmt(d) {
//   if (!d) return "";
//   const s = String(d);
//   return s.length >= 10 ? s.slice(0, 10) : s;
// }
// function money(n) {
//   return `₹ ${Number(n || 0).toFixed(2)}`;
// }
// function pillStyle(s) {
//   const st = String(s || "").toUpperCase();
//   const base = {
//     display: "inline-flex", alignItems: "center",
//     padding: "5px 11px", borderRadius: 999,
//     fontSize: 11.5, fontWeight: 700, border: "1px solid transparent",
//     whiteSpace: "nowrap",
//   };
//   if (st === "DELIVERED") return { ...base, background: "#f0fdf4", color: "#15803d", borderColor: "#bbf7d0" };
//   if (st === "CANCELLED") return { ...base, background: "#fef2f2", color: "#b91c1c", borderColor: "#fecaca" };
//   if (st === "SHIPPED") return { ...base, background: "#eff6ff", color: "#1d4ed8", borderColor: "#bfdbfe" };
//   if (st === "PROCESSING") return { ...base, background: "#eef2ff", color: "#4338ca", borderColor: "#c7d2fe" };
//   if (st === "CONFIRMED") return { ...base, background: "#eef2ff", color: "#4338ca", borderColor: "#c7d2fe" };
//   if (st === "PENDING") return { ...base, background: "#fffbeb", color: "#b45309", borderColor: "#fde68a" };
//   return { ...base, background: "#f3f4f6", color: "#374151", borderColor: "#e5e7eb" };
// }

// /* ── icons ── */
// const IconOrders = () => (
//   <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" /><line x1="3" y1="6" x2="21" y2="6" />
//     <path d="M16 10a4 4 0 01-8 0" />
//   </svg>
// );
// const IconSearch = () => (
//   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#aaa" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
//   </svg>
// );
// const IconDownload = () => (
//   <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
//     <polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" />
//   </svg>
// );
// const IconEye = () => (
//   <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
//     <circle cx="12" cy="12" r="3" />
//   </svg>
// );
// const IconBox = () => (
//   <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" />
//   </svg>
// );
// const IconClock = () => (
//   <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
//   </svg>
// );
// const IconTruck = () => (
//   <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6366f1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <rect x="1" y="3" width="15" height="13" /><polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
//     <circle cx="5.5" cy="18.5" r="2.5" /><circle cx="18.5" cy="18.5" r="2.5" />
//   </svg>
// );
// const IconCheckStat = () => (
//   <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <polyline points="20 6 9 17 4 12" />
//   </svg>
// );
// const IconEmpty = () => (
//   <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#ddd" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" /><line x1="3" y1="6" x2="21" y2="6" />
//   </svg>
// );

// /* ── styles ── */
// const S = {
//   page: { padding: "24px", background: "#f0f2f5", minHeight: "100%" },
//   head: { display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16, marginBottom: 20, flexWrap: "wrap" },
//   headLeft: { display: "flex", alignItems: "center", gap: 14 },
//   iconBox: { width: 44, height: 44, background: "#1a1f2e", borderRadius: 12, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
//   title: { margin: 0, fontSize: 22, fontWeight: 800, color: "#111", lineHeight: 1.2 },
//   sub: { marginTop: 3, color: "#888", fontSize: 13 },
//   exportBtn: { display: "inline-flex", alignItems: "center", gap: 7, padding: "10px 18px", background: "#1a1f2e", color: "#fff", border: "none", borderRadius: 12, fontSize: 13.5, fontWeight: 700, cursor: "pointer", whiteSpace: "nowrap" },
//   alert: { padding: "12px 16px", borderRadius: 12, background: "#ffe9e9", border: "1px solid #ffc8c8", color: "#a40000", marginBottom: 16, fontSize: 13.5 },
//   stats: { display: "flex", gap: 14, marginBottom: 20, flexWrap: "wrap" },
//   statCard: { background: "#fff", borderRadius: 14, padding: "16px 20px", display: "flex", alignItems: "center", gap: 14, border: "1px solid #eee", flex: 1, minWidth: 140 },
//   iconBlue: { width: 40, height: 40, borderRadius: 10, background: "#eff6ff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
//   iconYellow: { width: 40, height: 40, borderRadius: 10, background: "#fffbeb", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
//   iconIndigo: { width: 40, height: 40, borderRadius: 10, background: "#eef2ff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
//   iconGreen: { width: 40, height: 40, borderRadius: 10, background: "#f0fdf4", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
//   statLabel: { fontSize: 12, color: "#888", fontWeight: 500, marginBottom: 4 },
//   statVal: { fontSize: 22, fontWeight: 800, color: "#111", lineHeight: 1 },
//   filters: { display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap", alignItems: "center" },
//   searchWrap: { position: "relative", display: "flex", alignItems: "center", flex: 1, minWidth: 200 },
//   searchIcon: { position: "absolute", left: 12, pointerEvents: "none", display: "flex", alignItems: "center" },
//   searchInput: { width: "100%", padding: "10px 14px 10px 36px", border: "1.5px solid #e2e5ea", borderRadius: 12, outline: "none", background: "#fff", fontSize: 13.5, color: "#222", boxSizing: "border-box" },
//   filterSelect: { padding: "10px 12px", border: "1.5px solid #e2e5ea", borderRadius: 12, outline: "none", background: "#fff", fontSize: 13.5, color: "#444", cursor: "pointer" },
//   dateInput: { padding: "10px 12px", border: "1.5px solid #e2e5ea", borderRadius: 12, outline: "none", background: "#fff", fontSize: 13.5, color: "#444" },
//   tableCard: { background: "#fff", border: "1px solid #eee", borderRadius: 16, overflow: "hidden", boxShadow: "0 1px 4px rgba(0,0,0,0.04)" },
//   tableWrap: { overflowX: "auto", WebkitOverflowScrolling: "touch" },
//   table: { width: "100%", borderCollapse: "collapse", minWidth: 860 },
//   theadRow: { background: "#f7f8fa" },
//   th: { textAlign: "left", fontSize: 12, color: "#555", padding: "13px 16px", borderBottom: "1px solid #eeeff1", fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.4, whiteSpace: "nowrap" },
//   td: { padding: "13px 16px", borderBottom: "1px solid #f3f4f6", fontSize: 13.5, verticalAlign: "middle" },
//   tdSno: { padding: "13px 16px", borderBottom: "1px solid #f3f4f6", fontSize: 12.5, verticalAlign: "middle", color: "#aaa", fontWeight: 600 },
//   tdMono: { padding: "13px 16px", borderBottom: "1px solid #f3f4f6", fontSize: 13, verticalAlign: "middle", fontFamily: "ui-monospace, monospace", color: "#333", fontWeight: 700 },
//   tdMuted: { padding: "13px 16px", borderBottom: "1px solid #f3f4f6", fontSize: 13, verticalAlign: "middle", color: "#777" },
//   tdBold: { padding: "13px 16px", borderBottom: "1px solid #f3f4f6", fontSize: 13.5, verticalAlign: "middle", fontWeight: 700, color: "#111" },
//   tdProduct: { padding: "13px 16px", borderBottom: "1px solid #f3f4f6", fontSize: 13, verticalAlign: "middle", color: "#444", maxWidth: 200, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
//   statusSelect: { padding: "6px 10px", border: "1.5px solid #e2e5ea", borderRadius: 8, fontSize: 12.5, fontWeight: 600, color: "#333", background: "#fff", cursor: "pointer", outline: "none" },
//   viewBtn: { display: "inline-flex", alignItems: "center", justifyContent: "center", width: 32, height: 32, borderRadius: 8, background: "#f3f4f6", border: "1px solid #e5e7eb", cursor: "pointer" },
//   emptyTd: { padding: "48px 16px", textAlign: "center", borderBottom: "none" },
//   emptyInner: { display: "flex", flexDirection: "column", alignItems: "center", gap: 10 },
//   emptyText: { margin: 0, fontSize: 14, color: "#999", fontWeight: 500 },
//   footer: { display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 16px", borderTop: "1px solid #f3f4f6", fontSize: 13, color: "#888", flexWrap: "wrap", gap: 6 },
//   footerStrong: { color: "#333", fontWeight: 700 },
// };

// export default function OrdersList() {
//   const nav = useNavigate();
//   const { token, vendor } = useVendorAuth();
//   const vendorId = vendor?.id || "";

//   const [rows, setRows] = useState([]);
//   const [err, setErr] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [q, setQ] = useState("");
//   const [statusFilter, setStatusFilter] = useState("ALL");
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [savingId, setSavingId] = useState(null);

//   const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);
//   useEffect(() => {
//     const fn = () => setIsMobile(window.innerWidth <= 768);
//     window.addEventListener("resize", fn);
//     return () => window.removeEventListener("resize", fn);
//   }, []);

//   const load = useCallback(async () => {
//     try {
//       setErr(""); setLoading(true);
//       const res = await vendorApi.orders(token, vendorId);
//       setRows(Array.isArray(res?.orders) ? res.orders : []);
//     } catch (e) {
//       setErr(e?.message || "Failed to load orders");
//       setRows([]);
//     } finally { setLoading(false); }
//   }, [token, vendorId]);

//   useEffect(() => { load(); }, [load]);

// const normRows = useMemo(() => rows.map((o) => ({
//   ...o,
//   id: Number(o.order_id ?? o.id ?? 0),
//   created_at: o.created_at ?? "",
//   total: Number(o.vendor_amount ?? o.total_amount ?? 0) || 0,
//   delivery_charge: Number(o.delivery_charge ?? 0) || 0,
//   payable_amount: Number(o.payable_amount ?? 0) || 0,
//   customer: o.customer_name ?? o.customer ?? (o.user_id ? `User#${o.user_id}` : "-"),
//   payStatus: String(o.payment_status ?? "").toUpperCase(),
//   status: String(o.vendor_status ?? o.status ?? "PENDING").toUpperCase(),
//   overall_status: String(o.overall_status ?? o.status ?? "PENDING").toUpperCase(),
//   product_names: o.product_names ?? "",
//   product_ids: o.product_ids ?? "",
// })), [rows]);

//   const stats = useMemo(() => ({
//     totalOrders: normRows.length,
//     pending: normRows.filter((x) => x.status === "PENDING").length,
//     processing: normRows.filter((x) => x.status === "PROCESSING" || x.status === "CONFIRMED").length,
//     delivered: normRows.filter((x) => x.status === "DELIVERED").length,
//   }), [normRows]);

//   const filtered = useMemo(() => {
//     const qq = q.trim().toLowerCase();
//     return normRows.filter((o) => {
//       const text = `${o.id} ${o.customer} ${o.product_names} ${o.status} ${o.payStatus}`.toLowerCase();
//       if (qq && !text.includes(qq)) return false;
//       if (statusFilter !== "ALL" && o.status !== statusFilter) return false;
//       if (!inDateRange(o.created_at, fromDate, toDate)) return false;
//       return true;
//     });
//   }, [normRows, q, statusFilter, fromDate, toDate]);

//   const escapeCsv = (v) => {
//     const s = String(v ?? "");
//     return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
//   };

//   const exportCSV = () => {
//     const headers = ["S.NO", "ORDER_ID", "CUSTOMER", "DATE", "PRODUCT", "AMOUNT", "PAYMENT_STATUS", "STATUS"];
//     const lines = [headers.join(",")];
//     let sn = 1;
//     filtered.forEach((o) => {
//       const products = String(o.product_names ?? "").split(",").map((x) => x.trim()).filter(Boolean);
//       (products.length ? products : ["-"]).forEach((p) => {
//         lines.push([sn++, `YURO-${String(o.id).padStart(4, "0")}`, o.customer, dateFmt(o.created_at), p, o.total, o.payStatus, o.status].map(escapeCsv).join(","));
//       });
//     });
//     const blob = new Blob([lines.join("\n")], { type: "text/csv;charset=utf-8" });
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url; a.download = `orders_${new Date().toISOString().slice(0, 10)}.csv`;
//     document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
//   };

//   // In changeStatus — update vendor_status in local state
//   // const changeStatus = async (orderId, nextStatus) => {
//   //   try {
//   //     setSavingId(orderId);
//   //     const res = await vendorApi.updateOrderStatus(token, orderId, nextStatus);
//   //     setRows((prev) =>
//   //       prev.map((x) =>
//   //         Number(x.order_id ?? x.id) === orderId
//   //           ? {
//   //             ...x,
//   //             vendor_status: nextStatus,           // ← what THIS vendor set
//   //             overall_status: res?.overall_status ?? x.overall_status, // ← derived overall
//   //           }
//   //           : x
//   //       )
//   //     );
//   //   } catch (e) { alert(e?.message || "Status update failed"); }
//   //   finally { setSavingId(null); }
//   // };





//   // In changeStatus — prevent status changes after delivery
// const changeStatus = async (orderId, nextStatus) => {
//   // Find the current order to check its status
//   const currentOrder = rows.find(x => Number(x.order_id ?? x.id) === orderId);
  
//   // ✅ CRITICAL: If order is already DELIVERED, prevent any status change
//   if (currentOrder?.status === "DELIVERED") {
//     alert("❌ Cannot change status: Order has already been delivered. Delivery status is final.");
//     return;
//   }
  
//   // ✅ Optional: Prevent changing from CANCELLED as well (usually final)
//   if (currentOrder?.status === "CANCELLED") {
//     alert("❌ Cannot change status: Order has been cancelled. Cancelled status is final.");
//     return;
//   }
  
//   try {
//     setSavingId(orderId);
//     const res = await vendorApi.updateOrderStatus(token, orderId, nextStatus);
    
//     // Update local state with new status
//     setRows((prev) =>
//       prev.map((x) =>
//         Number(x.order_id ?? x.id) === orderId
//           ? {
//               ...x,
//               vendor_status: nextStatus,
//               overall_status: res?.overall_status ?? x.overall_status,
//             }
//           : x
//       )
//     );
    
//     // Show success message
//     if (nextStatus === "DELIVERED") {
//       alert("✅ Order marked as delivered! Commission has been credited to your wallet.");
//     }
//   } catch (e) { 
//     alert(e?.message || "Status update failed"); 
//   } finally { 
//     setSavingId(null); 
//   }
// };



//   // ✅ Use absolute path to avoid relative path issues
//   const viewOrder = (id) => nav(`/orders/${id}`);

//   return (
//     <div style={S.page}>

//       {/* Header */}
//       <div style={S.head}>
//         <div style={S.headLeft}>
//           <div style={S.iconBox}><IconOrders /></div>
//           <div>
//             <h2 style={S.title}>Orders</h2>
//             <div style={S.sub}>Manage and track all your orders</div>
//             <div style={{ color:'red' }}>Once you update the order status as delivered , you can not change it again .</div>
//           </div>
//         </div>
//         <button style={S.exportBtn} onClick={exportCSV}>
//           <IconDownload /> Export Orders
//         </button>
//       </div>

//       {err ? <div style={S.alert}>{err}</div> : null}

//       {/* Stats */}
//       <div style={S.stats}>
//         <div style={S.statCard}>
//           <div style={S.iconBlue}><IconBox /></div>
//           <div>
//             <div style={S.statLabel}>Total Orders</div>
//             <div style={S.statVal}>{stats.totalOrders}</div>
//           </div>
//         </div>
//         <div style={S.statCard}>
//           <div style={S.iconYellow}><IconClock /></div>
//           <div>
//             <div style={S.statLabel}>Pending</div>
//             <div style={{ ...S.statVal, color: "#d97706" }}>{stats.pending}</div>
//           </div>
//         </div>
//         <div style={S.statCard}>
//           <div style={S.iconIndigo}><IconTruck /></div>
//           <div>
//             <div style={S.statLabel}>Processing</div>
//             <div style={{ ...S.statVal, color: "#4f46e5" }}>{stats.processing}</div>
//           </div>
//         </div>
//         <div style={S.statCard}>
//           <div style={S.iconGreen}><IconCheckStat /></div>
//           <div>
//             <div style={S.statLabel}>Delivered</div>
//             <div style={{ ...S.statVal, color: "#16a34a" }}>{stats.delivered}</div>
//           </div>
//         </div>
//       </div>

//       {/* Filters */}
//       <div style={S.filters}>
//         <div style={S.searchWrap}>
//           <span style={S.searchIcon}><IconSearch /></span>
//           <input style={S.searchInput} value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search orders..." />
//         </div>
//         <select style={S.filterSelect} value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
//           <option value="ALL">All Status</option>
//           <option value="PENDING">Pending</option>
//           <option value="CONFIRMED">Confirmed</option>
//           <option value="PROCESSING">Processing</option>
//           <option value="SHIPPED">Shipped</option>
//           <option value="DELIVERED">Delivered</option>
//           <option value="CANCELLED">Cancelled</option>
//         </select>
//         <input type="date" style={S.dateInput} value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
//         <input type="date" style={S.dateInput} value={toDate} onChange={(e) => setToDate(e.target.value)} />
//       </div>

//       {/* Table */}
//       <div style={{ ...S.tableCard, margin: isMobile ? "0 -24px" : 0, borderRadius: isMobile ? 0 : 16 }}>
//         <div style={S.tableWrap}>
//           <table style={S.table}>
//             <thead>
//               <tr style={S.theadRow}>
//                 <th style={S.th}>S.No</th>
//                 <th style={S.th}>Order ID</th>
//                 <th style={S.th}>Customer</th>
//                 <th style={S.th}>Date</th>
//                 <th style={S.th}>Product</th>
//                 <th style={S.th}>Amount</th>
//                 <th style={S.th}>Delivery</th>
//                 <th style={S.th}>Payable</th>
//                 <th style={S.th}>Payment</th>
//                 <th style={S.th}>Status</th>
//                 <th style={S.th}>Time Left</th>
//                 <th style={{ ...S.th, textAlign: "right" }}>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {!loading && filtered.length === 0 ? (
//                 <tr>
//                  <td colSpan={11} style={S.emptyTd}>
//                     <div style={S.emptyInner}>
//                       <IconEmpty />
//                       <p style={S.emptyText}>No orders found</p>
//                     </div>
//                   </td>
//                 </tr>
//               ) : null}

//               {filtered.map((o, idx) => (
//                 <tr key={o.id} style={{ background: "transparent" }}
//                   onMouseEnter={(e) => (e.currentTarget.style.background = "#fafbfc")}
//                   onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
//                 >
//                   <td style={S.tdSno}>{idx + 1}</td>
//                   <td style={S.tdMono}>{`YURO-${String(o.id).padStart(4, "0")}`}</td>
//                   <td style={S.tdBold}>{o.customer}</td>
//                   <td style={S.tdMuted}>{dateFmt(o.created_at)}</td>
//                   <td style={S.tdProduct} title={o.product_ids || ""}>{o.product_names || "-"}</td>
//                   <td style={S.tdBold}>{money(o.total)}</td>
//                   <td style={S.tdBold}>{money(o.delivery_charge)}</td>
//                   <td style={S.tdBold}>{money(o.payable_amount)}</td>
//                   <td style={S.tdMuted}>{o.payStatus || "-"}</td>
//                   <td style={S.td}>
//                     <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
//                       <span style={pillStyle(o.status)}>{o.status}</span>
//                       {/* Show overall only if it differs from vendor's status */}
//                       {o.overall_status !== o.status && (
//                         <span style={{ ...pillStyle(o.overall_status), opacity: 0.6, fontSize: 10.5 }}>
//                           Overall: {o.overall_status}
//                         </span>
//                       )}
// <select
//   style={S.statusSelect}
//   value={o.status}
//   disabled={savingId === o.id || o.status === "DELIVERED" || o.status === "CANCELLED"}
//   onChange={(e) => changeStatus(o.id, e.target.value)}
// >
//   <option value="PENDING">Pending</option>
//   <option value="CONFIRMED">Confirmed</option>
//   <option value="PROCESSING">Processing</option>
//   <option value="SHIPPED">Shipped</option>
//   <option value="DELIVERED">Delivered</option>
//   <option value="CANCELLED">Cancelled</option>
// </select>
//                     </div>
//                   </td>
//                   <td style={S.td}>
//                     <OrderTimer createdAt={o.created_at} status={o.status} />
//                   </td>
//                   <td style={{ ...S.td, textAlign: "right" }}>
//                     {/* ✅ viewOrder uses relative path — no /vendor/ prefix */}
//                     <button style={S.viewBtn} onClick={() => viewOrder(o.id)} title="View order">
//                       <IconEye />
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         <div style={S.footer}>
//           <span>
//             Showing <strong style={S.footerStrong}>{filtered.length}</strong> of{" "}
//             <strong style={S.footerStrong}>{normRows.length}</strong> orders
//           </span>
//           {loading && <span style={{ color: "#aaa" }}>Loading...</span>}
//         </div>
//       </div>
//     </div>
//   );
// }

//updated file

import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { vendorApi } from "../../services/vendorApi";
import { useVendorAuth } from "../../store/vendorAuthStore";
import { OrderTimer } from "../../components/OrderTimer";

/* ── helpers ── */
function toDateOnly(d) { return d ? String(d).slice(0, 10) : ""; }
function inDateRange(orderDate, from, to) {
  const od = toDateOnly(orderDate);
  if (!od) return true;
  if (from && od < from) return false;
  if (to && od > to) return false;
  return true;
}
function dateFmt(d) {
  if (!d) return "";
  const s = String(d);
  return s.length >= 10 ? s.slice(0, 10) : s;
}
function money(n) {
  return `₹ ${Number(n || 0).toFixed(2)}`;
}
function pillStyle(s) {
  const st = String(s || "").toUpperCase();
  const base = {
    display: "inline-flex", alignItems: "center",
    padding: "5px 11px", borderRadius: 999,
    fontSize: 11.5, fontWeight: 700, border: "1px solid transparent",
    whiteSpace: "nowrap",
  };
  if (st === "DELIVERED") return { ...base, background: "#f0fdf4", color: "#15803d", borderColor: "#bbf7d0" };
  if (st === "CANCELLED") return { ...base, background: "#fef2f2", color: "#b91c1c", borderColor: "#fecaca" };
  if (st === "SHIPPED") return { ...base, background: "#eff6ff", color: "#1d4ed8", borderColor: "#bfdbfe" };
  if (st === "PROCESSING") return { ...base, background: "#eef2ff", color: "#4338ca", borderColor: "#c7d2fe" };
  if (st === "CONFIRMED") return { ...base, background: "#eef2ff", color: "#4338ca", borderColor: "#c7d2fe" };
  if (st === "PENDING") return { ...base, background: "#fffbeb", color: "#b45309", borderColor: "#fde68a" };
  return { ...base, background: "#f3f4f6", color: "#374151", borderColor: "#e5e7eb" };
}

/* ── icons ── */
const IconOrders = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" /><line x1="3" y1="6" x2="21" y2="6" />
    <path d="M16 10a4 4 0 01-8 0" />
  </svg>
);
const IconSearch = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#aaa" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);
const IconDownload = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
    <polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" />
  </svg>
);
const IconEye = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);
const IconBox = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" />
  </svg>
);
const IconClock = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
  </svg>
);
const IconTruck = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6366f1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="1" y="3" width="15" height="13" /><polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
    <circle cx="5.5" cy="18.5" r="2.5" /><circle cx="18.5" cy="18.5" r="2.5" />
  </svg>
);
const IconCheckStat = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);
const IconEmpty = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#ddd" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" /><line x1="3" y1="6" x2="21" y2="6" />
  </svg>
);
const IconCheckCircle = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" /><polyline points="9 12 11 14 15 10" />
  </svg>
);
const IconAlertCircle = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>
);
const IconCopy = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="9" y="9" width="13" height="13" rx="2" ry="2" /><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
  </svg>
);
const IconUpload = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" />
  </svg>
);

/* ── styles ── */
const S = {
  page: { padding: "24px", background: "#f0f2f5", minHeight: "100%" },
  head: { display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16, marginBottom: 20, flexWrap: "wrap" },
  headLeft: { display: "flex", alignItems: "center", gap: 14 },
  iconBox: { width: 44, height: 44, background: "#1a1f2e", borderRadius: 12, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
  title: { margin: 0, fontSize: 22, fontWeight: 800, color: "#111", lineHeight: 1.2 },
  sub: { marginTop: 3, color: "#888", fontSize: 13 },
  exportBtn: { display: "inline-flex", alignItems: "center", gap: 7, padding: "10px 18px", background: "#1a1f2e", color: "#fff", border: "none", borderRadius: 12, fontSize: 13.5, fontWeight: 700, cursor: "pointer", whiteSpace: "nowrap" },
  alert: { padding: "12px 16px", borderRadius: 12, background: "#ffe9e9", border: "1px solid #ffc8c8", color: "#a40000", marginBottom: 16, fontSize: 13.5 },
  stats: { display: "flex", gap: 14, marginBottom: 20, flexWrap: "wrap" },
  statCard: { background: "#fff", borderRadius: 14, padding: "16px 20px", display: "flex", alignItems: "center", gap: 14, border: "1px solid #eee", flex: 1, minWidth: 140 },
  iconBlue: { width: 40, height: 40, borderRadius: 10, background: "#eff6ff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
  iconYellow: { width: 40, height: 40, borderRadius: 10, background: "#fffbeb", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
  iconIndigo: { width: 40, height: 40, borderRadius: 10, background: "#eef2ff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
  iconGreen: { width: 40, height: 40, borderRadius: 10, background: "#f0fdf4", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
  statLabel: { fontSize: 12, color: "#888", fontWeight: 500, marginBottom: 4 },
  statVal: { fontSize: 22, fontWeight: 800, color: "#111", lineHeight: 1 },
  filters: { display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap", alignItems: "center" },
  searchWrap: { position: "relative", display: "flex", alignItems: "center", flex: 1, minWidth: 200 },
  searchIcon: { position: "absolute", left: 12, pointerEvents: "none", display: "flex", alignItems: "center" },
  searchInput: { width: "100%", padding: "10px 14px 10px 36px", border: "1.5px solid #e2e5ea", borderRadius: 12, outline: "none", background: "#fff", fontSize: 13.5, color: "#222", boxSizing: "border-box" },
  filterSelect: { padding: "10px 12px", border: "1.5px solid #e2e5ea", borderRadius: 12, outline: "none", background: "#fff", fontSize: 13.5, color: "#444", cursor: "pointer" },
  dateInput: { padding: "10px 12px", border: "1.5px solid #e2e5ea", borderRadius: 12, outline: "none", background: "#fff", fontSize: 13.5, color: "#444" },
  tableCard: { background: "#fff", border: "1px solid #eee", borderRadius: 16, overflow: "hidden", boxShadow: "0 1px 4px rgba(0,0,0,0.04)" },
  tableWrap: { overflowX: "auto", WebkitOverflowScrolling: "touch" },
  table: { width: "100%", borderCollapse: "collapse", minWidth: 860 },
  theadRow: { background: "#f7f8fa" },
  th: { textAlign: "left", fontSize: 12, color: "#555", padding: "13px 16px", borderBottom: "1px solid #eeeff1", fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.4, whiteSpace: "nowrap" },
  td: { padding: "13px 16px", borderBottom: "1px solid #f3f4f6", fontSize: 13.5, verticalAlign: "middle" },
  tdSno: { padding: "13px 16px", borderBottom: "1px solid #f3f4f6", fontSize: 12.5, verticalAlign: "middle", color: "#aaa", fontWeight: 600 },
  tdMono: { padding: "13px 16px", borderBottom: "1px solid #f3f4f6", fontSize: 13, verticalAlign: "middle", fontFamily: "ui-monospace, monospace", color: "#333", fontWeight: 700 },
  tdMuted: { padding: "13px 16px", borderBottom: "1px solid #f3f4f6", fontSize: 13, verticalAlign: "middle", color: "#777" },
  tdBold: { padding: "13px 16px", borderBottom: "1px solid #f3f4f6", fontSize: 13.5, verticalAlign: "middle", fontWeight: 700, color: "#111" },
  tdProduct: { padding: "13px 16px", borderBottom: "1px solid #f3f4f6", fontSize: 13, verticalAlign: "middle", color: "#444", maxWidth: 200, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
  statusSelect: { padding: "6px 10px", border: "1.5px solid #e2e5ea", borderRadius: 8, fontSize: 12.5, fontWeight: 600, color: "#333", background: "#fff", cursor: "pointer", outline: "none" },
  viewBtn: { display: "inline-flex", alignItems: "center", justifyContent: "center", width: 32, height: 32, borderRadius: 8, background: "#f3f4f6", border: "1px solid #e5e7eb", cursor: "pointer" },
  emptyTd: { padding: "48px 16px", textAlign: "center", borderBottom: "none" },
  emptyInner: { display: "flex", flexDirection: "column", alignItems: "center", gap: 10 },
  emptyText: { margin: 0, fontSize: 14, color: "#999", fontWeight: 500 },
  footer: { display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 16px", borderTop: "1px solid #f3f4f6", fontSize: 13, color: "#888", flexWrap: "wrap", gap: 6 },
  footerStrong: { color: "#333", fontWeight: 700 },
  trackingRow: { display: "flex", alignItems: "center", gap: 6, marginTop: 4 },
  trackingText: { fontSize: 11, color: "#1d4ed8", fontFamily: "ui-monospace, monospace", fontWeight: 700 },
  trackingCopyBtn: { display: "inline-flex", alignItems: "center", justifyContent: "center", width: 20, height: 20, borderRadius: 6, background: "#eff6ff", border: "1px solid #bfdbfe", color: "#1d4ed8", cursor: "pointer", padding: 0 },
};

/* ── confirm-ship modal styles ── */
const modalS = {
  overlay: { position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: 16 },
  box: { background: "#fff", borderRadius: 16, padding: 24, width: "100%", maxWidth: 380, boxShadow: "0 10px 40px rgba(0,0,0,0.25)" },
  head: { display: "flex", alignItems: "center", gap: 12, marginBottom: 14 },
  iconBox: { width: 40, height: 40, background: "#1a1f2e", borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
  title: { margin: 0, fontSize: 16, fontWeight: 800, color: "#111" },
  sub: { fontSize: 12.5, color: "#888", marginTop: 2 },
  note: { fontSize: 12.5, color: "#666", background: "#f7f8fa", border: "1px solid #eee", borderRadius: 10, padding: "10px 12px", marginBottom: 20, lineHeight: 1.5 },
  footer: { display: "flex", justifyContent: "flex-end", gap: 10 },
  cancelBtn: { padding: "9px 16px", borderRadius: 10, border: "1.5px solid #e2e5ea", background: "#fff", fontSize: 13, fontWeight: 700, color: "#444", cursor: "pointer" },
  confirmBtn: { padding: "9px 16px", borderRadius: 10, border: "none", background: "#1a1f2e", color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer" },
  confirmBtnDisabled: { opacity: 0.6, cursor: "not-allowed" },
  fileInput: { display: "block", width: "100%", padding: "8px", border: "1.5px dashed #e2e5ea", borderRadius: 10, marginTop: 10, cursor: "pointer", fontSize: 13, color: "#666", boxSizing: "border-box" },
  imgPreview: { width: "100%", maxHeight: 150, objectFit: "contain", marginTop: 10, borderRadius: 10, border: "1px solid #eee" },
};

/* ── toast styles ── */
const toastS = {
  base: { position: "fixed", top: 20, right: 20, display: "flex", alignItems: "flex-start", gap: 10, padding: "13px 18px", borderRadius: 12, fontSize: 13.5, fontWeight: 600, boxShadow: "0 6px 24px rgba(0,0,0,0.18)", zIndex: 1100, maxWidth: 340, lineHeight: 1.4 },
  success: { background: "#f0fdf4", color: "#15803d", border: "1px solid #bbf7d0" },
  error: { background: "#fef2f2", color: "#b91c1c", border: "1px solid #fecaca" },
};

export default function OrdersList() {
  const nav = useNavigate();
  const { token, vendor } = useVendorAuth();
  const vendorId = vendor?.id || "";

  const [rows, setRows] = useState([]);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");
  const [statusFilter, setStatusFilter] = useState("ALL");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [savingId, setSavingId] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;

  // ── toast + ship-confirm modal state ──
  const [toast, setToast] = useState(null); // { type: 'success' | 'error', message }
  const [shipModal, setShipModal] = useState(null); // { orderId }
  const [deliveryModal, setDeliveryModal] = useState(null); // { orderId }
  const [deliveryImage, setDeliveryImage] = useState(null);
  const [previewModal, setPreviewModal] = useState(null); // { orderId, imageUrl }

  const showToast = (type, message) => {
    setToast({ type, message });
    setTimeout(() => setToast(null), 3000);
  };

  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);
  useEffect(() => {
    const fn = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", fn);
    return () => window.removeEventListener("resize", fn);
  }, []);

  const load = useCallback(async () => {
    try {
      setErr(""); setLoading(true);
      const res = await vendorApi.orders(token, vendorId);
      setRows(Array.isArray(res?.orders) ? res.orders : []);
    } catch (e) {
      setErr(e?.message || "Failed to load orders");
      setRows([]);
    } finally { setLoading(false); }
  }, [token, vendorId]);

  useEffect(() => { load(); }, [load]);

  const normRows = useMemo(() => rows.map((o) => ({
    ...o,
    id: Number(o.order_id ?? o.id ?? 0),
    created_at: o.created_at ?? "",
    total: Number(o.vendor_amount ?? o.total_amount ?? 0) || 0,
    delivery_charge: Number(o.delivery_charge ?? 0) || 0,
    payable_amount: Number(o.payable_amount ?? 0) || 0,
    customer: o.customer_name ?? o.customer ?? (o.user_id ? `User#${o.user_id}` : "-"),
    payStatus: String(o.payment_status ?? "").toUpperCase(),
    status: String(o.vendor_status ?? o.status ?? "PENDING").toUpperCase(),
    overall_status: String(o.overall_status ?? o.status ?? "PENDING").toUpperCase(),
    product_names: o.product_names ?? "",
    product_ids: o.product_ids ?? "",
    tracking_no: o.tracking_no ?? "",
    delivery_image: o.delivery_image ?? "",
  })), [rows]);

  const stats = useMemo(() => ({
    totalOrders: normRows.length,
    pending: normRows.filter((x) => x.status === "PENDING").length,
    processing: normRows.filter((x) => x.status === "PROCESSING" || x.status === "CONFIRMED").length,
    delivered: normRows.filter((x) => x.status === "DELIVERED").length,
  }), [normRows]);

  const filtered = useMemo(() => {
    const qq = q.trim().toLowerCase();
    return normRows.filter((o) => {
      const text = `${o.id} ${o.customer} ${o.product_names} ${o.status} ${o.payStatus}`.toLowerCase();
      if (qq && !text.includes(qq)) return false;
      if (statusFilter !== "ALL" && o.status !== statusFilter) return false;
      if (!inDateRange(o.created_at, fromDate, toDate)) return false;
      return true;
    });
  }, [normRows, q, statusFilter, fromDate, toDate]);

  useEffect(() => {
    setCurrentPage(1);
  }, [q, statusFilter, fromDate, toDate]);

  const paginatedRows = useMemo(() => {
    const start = (currentPage - 1) * itemsPerPage;
    return filtered.slice(start, start + itemsPerPage);
  }, [filtered, currentPage]);

  const escapeCsv = (v) => {
    const s = String(v ?? "");
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };

  const exportCSV = () => {
    const headers = ["S.NO", "ORDER_ID", "CUSTOMER", "DATE", "PRODUCT", "AMOUNT", "PAYMENT_STATUS", "STATUS", "TRACKING_NO"];
    const lines = [headers.join(",")];
    let sn = 1;
    filtered.forEach((o) => {
      const products = String(o.product_names ?? "").split(",").map((x) => x.trim()).filter(Boolean);
      (products.length ? products : ["-"]).forEach((p) => {
        lines.push([sn++, `YURO-${String(o.id).padStart(4, "0")}`, o.customer, dateFmt(o.created_at), p, o.total, o.payStatus, o.status, o.tracking_no || "-"].map(escapeCsv).join(","));
      });
    });
    const blob = new Blob([lines.join("\n")], { type: "text/csv;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = `orders_${new Date().toISOString().slice(0, 10)}.csv`;
    document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
  };

  /**
   * Handles a status change from the dropdown.
   * - Blocks changes if the order is already DELIVERED or CANCELLED (final states).
   * - Tracking numbers are no longer typed by the vendor: when nextStatus is
   *   "SHIPPED", the backend (update_status.php) auto-generates one and returns
   *   it in the response as res.tracking_no. We just store whatever comes back.
   * - Shows a toast with the result instead of a browser alert().
   */
  const changeStatus = async (orderId, nextStatus, imageFile = null) => {
    const currentOrder = rows.find(x => Number(x.order_id ?? x.id) === orderId);

    if (currentOrder?.status === "DELIVERED" || String(currentOrder?.vendor_status).toUpperCase() === "DELIVERED") {
      showToast("error", "Cannot change status: order has already been delivered.");
      return;
    }
    if (currentOrder?.status === "CANCELLED" || String(currentOrder?.vendor_status).toUpperCase() === "CANCELLED") {
      showToast("error", "Cannot change status: order has been cancelled.");
      return;
    }

    try {
      setSavingId(orderId);

      // No tracking number is sent — the backend generates it automatically for SHIPPED.
      const res = await vendorApi.updateOrderStatus(token, orderId, nextStatus, "", imageFile);
      const returnedTracking = res?.tracking_no || "";

      setRows((prev) =>
        prev.map((x) =>
          Number(x.order_id ?? x.id) === orderId
            ? {
                ...x,
                vendor_status: nextStatus,
                tracking_no: returnedTracking || x.tracking_no,
                delivery_image: res?.delivery_image || x.delivery_image,
                overall_status: res?.overall_status ?? x.overall_status,
                status: nextStatus // Also update the mapped status property so UI reacts
              }
            : x
        )
      );

      if (nextStatus === "DELIVERED") {
        showToast("success", "Order marked as delivered! Commission credited to your wallet.");
      } else if (nextStatus === "SHIPPED") {
        showToast("success", returnedTracking ? `Order shipped — tracking #${returnedTracking} generated.` : "Order marked as shipped.");
      } else {
        showToast("success", `Status updated to ${nextStatus}.`);
      }
    } catch (e) {
      showToast("error", e?.message || "Status update failed");
    } finally {
      setSavingId(null);
    }
  };

  const copyTracking = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      showToast("success", "Tracking number copied.");
    } catch {
      // clipboard API unavailable — silently ignore
    }
  };

  // ✅ Use absolute path to avoid relative path issues
  const viewOrder = (id) => nav(`/orders/${id}`);

  return (
    <div style={S.page}>

      {/* Header */}
      <div style={S.head}>
        <div style={S.headLeft}>
          <div style={S.iconBox}><IconOrders /></div>
          <div>
            <h2 style={S.title}>Orders</h2>
            <div style={S.sub}>Manage and track all your orders</div>
            <div style={{ color: 'red' }}>Once you update the order status as delivered , you can not change it again .</div>
          </div>
        </div>
        <button style={S.exportBtn} onClick={exportCSV}>
          <IconDownload /> Export Orders
        </button>
      </div>

      {err ? <div style={S.alert}>{err}</div> : null}

      {/* Stats */}
      <div style={S.stats}>
        <div style={S.statCard}>
          <div style={S.iconBlue}><IconBox /></div>
          <div>
            <div style={S.statLabel}>Total Orders</div>
            <div style={S.statVal}>{stats.totalOrders}</div>
          </div>
        </div>
        <div style={S.statCard}>
          <div style={S.iconYellow}><IconClock /></div>
          <div>
            <div style={S.statLabel}>Pending</div>
            <div style={{ ...S.statVal, color: "#d97706" }}>{stats.pending}</div>
          </div>
        </div>
        <div style={S.statCard}>
          <div style={S.iconIndigo}><IconTruck /></div>
          <div>
            <div style={S.statLabel}>Processing</div>
            <div style={{ ...S.statVal, color: "#4f46e5" }}>{stats.processing}</div>
          </div>
        </div>
        <div style={S.statCard}>
          <div style={S.iconGreen}><IconCheckStat /></div>
          <div>
            <div style={S.statLabel}>Delivered</div>
            <div style={{ ...S.statVal, color: "#16a34a" }}>{stats.delivered}</div>
          </div>
        </div>
      </div>

      {/* Filters */}
      <div style={S.filters}>
        <div style={S.searchWrap}>
          <span style={S.searchIcon}><IconSearch /></span>
          <input style={S.searchInput} value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search orders..." />
        </div>
        <select style={S.filterSelect} value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
          <option value="ALL">All Status</option>
          <option value="PENDING">Pending</option>
          <option value="CONFIRMED">Confirmed</option>
          <option value="PROCESSING">Processing</option>
          <option value="SHIPPED">Shipped</option>
          <option value="DELIVERED">Delivered</option>
          <option value="CANCELLED">Cancelled</option>
        </select>
        <input type="date" style={S.dateInput} value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
        <input type="date" style={S.dateInput} value={toDate} onChange={(e) => setToDate(e.target.value)} />
      </div>

      {/* Table */}
      <div style={{ ...S.tableCard, margin: isMobile ? "0 -24px" : 0, borderRadius: isMobile ? 0 : 16 }}>
        <div style={S.tableWrap}>
          <table style={S.table}>
            <thead>
              <tr style={S.theadRow}>
                <th style={S.th}>S.No</th>
                <th style={S.th}>Order ID</th>
                <th style={S.th}>Customer</th>
                <th style={S.th}>Date</th>
                <th style={S.th}>Product</th>
                <th style={S.th}>Amount</th>
                <th style={S.th}>Delivery</th>
                <th style={S.th}>Payable</th>
                <th style={S.th}>Payment</th>
                <th style={S.th}>Status</th>
                <th style={S.th}>Time Left</th>
                <th style={{ ...S.th, textAlign: "right" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {!loading && filtered.length === 0 ? (
                <tr>
                  <td colSpan={11} style={S.emptyTd}>
                    <div style={S.emptyInner}>
                      <IconEmpty />
                      <p style={S.emptyText}>No orders found</p>
                    </div>
                  </td>
                </tr>
              ) : null}

              {paginatedRows.map((o, idx) => (
                <tr key={o.id} style={{ background: "transparent" }}
                  onMouseEnter={(e) => (e.currentTarget.style.background = "#fafbfc")}
                  onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                >
                  <td style={S.tdSno}>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
                  <td style={S.tdMono}>{`YURO-${String(o.id).padStart(4, "0")}`}</td>
                  <td style={S.tdBold}>{o.customer}</td>
                  <td style={S.tdMuted}>{dateFmt(o.created_at)}</td>
                  <td style={S.tdProduct} title={o.product_ids || ""}>{o.product_names || "-"}</td>
                  <td style={S.tdBold}>{money(o.total)}</td>
                  <td style={S.tdBold}>{money(o.delivery_charge)}</td>
                  <td style={S.tdBold}>{money(o.payable_amount)}</td>
                  <td style={S.tdMuted}>{o.payStatus || "-"}</td>
                  <td style={S.td}>
                    <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                      <span style={pillStyle(o.status)}>{o.status}</span>
                      {/* Show overall only if it differs from vendor's status */}
                      {o.overall_status !== o.status && (
                        <span style={{ ...pillStyle(o.overall_status), opacity: 0.6, fontSize: 10.5 }}>
                          Overall: {o.overall_status}
                        </span>
                      )}
                      <select
                        style={S.statusSelect}
                        value={o.status}
                        disabled={savingId === o.id || o.status === "DELIVERED" || o.status === "CANCELLED"}
                        onChange={(e) => {
                          const next = e.target.value;
                          if (next === o.status) return;
                          if (next === "SHIPPED") {
                            // Just confirm — no tracking input needed, backend generates it.
                            setShipModal({ orderId: o.id });
                          } else if (next === "DELIVERED") {
                            setDeliveryModal({ orderId: o.id });
                          } else {
                            changeStatus(o.id, next);
                          }
                        }}
                      >
                        <option value="PENDING">Pending</option>
                        <option value="CONFIRMED">Confirmed</option>
                        <option value="PROCESSING">Processing</option>
                        <option value="SHIPPED">Shipped</option>
                        <option value="DELIVERED">Delivered</option>
                        <option value="CANCELLED">Cancelled</option>
                      </select>
                      {savingId === o.id && <span style={{ fontSize: 11, color: "#aaa" }}>Saving…</span>}
                    </div>

                    {/* Auto-generated tracking number, shown once the order is shipped */}
                    {o.status === "SHIPPED" && o.tracking_no && (
                      <div style={S.trackingRow}>
                        <span style={S.trackingText}>Tracking: {o.tracking_no}</span>
                        <button
                          style={S.trackingCopyBtn}
                          title="Copy tracking number"
                          onClick={() => copyTracking(o.tracking_no)}
                        >
                          <IconCopy />
                        </button>
                      </div>
                    )}

                    {/* Delivery image proof */}
                    {o.status === "DELIVERED" && o.delivery_image && (
                      <div style={{ marginTop: 8 }}>
                        <button
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 4,
                            fontSize: 11.5,
                            color: "#2563eb",
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            padding: 0,
                            textDecoration: "underline"
                          }}
                          onClick={() => setPreviewModal({ orderId: o.id, imageUrl: `https://xiadot.com/vendor_api/${o.delivery_image}` })}
                        >
                          <IconEye /> View Delivery Proof
                        </button>
                      </div>
                    )}
                  </td>
                  <td style={S.td}>
                    <OrderTimer createdAt={o.created_at} status={o.status} />
                  </td>
                  <td style={{ ...S.td, textAlign: "right" }}>
                    {/* ✅ viewOrder uses relative path — no /vendor/ prefix */}
                    <button style={S.viewBtn} onClick={() => viewOrder(o.id)} title="View order">
                      <IconEye />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div style={S.footer}>
          <span>
            Showing <strong style={S.footerStrong}>{filtered.length > 0 ? (currentPage - 1) * itemsPerPage + 1 : 0}</strong> to <strong style={S.footerStrong}>{Math.min(currentPage * itemsPerPage, filtered.length)}</strong> of <strong style={S.footerStrong}>{filtered.length}</strong> orders (Total: {normRows.length})
          </span>
          {loading && <span style={{ color: "#aaa" }}>Loading...</span>}
          {filtered.length > itemsPerPage && (
            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <button
                onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                disabled={currentPage === 1}
                style={{
                  padding: "6px 12px", borderRadius: "8px", border: "1px solid #e2e5ea",
                  background: currentPage === 1 ? "#f9fafb" : "#fff",
                  color: currentPage === 1 ? "#aaa" : "#333",
                  cursor: currentPage === 1 ? "not-allowed" : "pointer",
                  fontSize: 13, fontWeight: 600
                }}
              >
                Previous
              </button>
              <span style={{ fontSize: 13, color: "#555", fontWeight: 500 }}>
                Page {currentPage} of {Math.ceil(filtered.length / itemsPerPage)}
              </span>
              <button
                onClick={() => setCurrentPage(p => Math.min(Math.ceil(filtered.length / itemsPerPage), p + 1))}
                disabled={currentPage === Math.ceil(filtered.length / itemsPerPage)}
                style={{
                  padding: "6px 12px", borderRadius: "8px", border: "1px solid #e2e5ea",
                  background: currentPage === Math.ceil(filtered.length / itemsPerPage) ? "#f9fafb" : "#fff",
                  color: currentPage === Math.ceil(filtered.length / itemsPerPage) ? "#aaa" : "#333",
                  cursor: currentPage === Math.ceil(filtered.length / itemsPerPage) ? "not-allowed" : "pointer",
                  fontSize: 13, fontWeight: 600
                }}
              >
                Next
              </button>
            </div>
          )}
        </div>
      </div>

      {/* ── Ship confirmation modal: no tracking input — backend auto-generates it ── */}
      {shipModal && (
        <div style={modalS.overlay} onClick={() => setShipModal(null)}>
          <div style={modalS.box} onClick={(e) => e.stopPropagation()}>
            <div style={modalS.head}>
              <div style={modalS.iconBox}><IconTruck /></div>
              <div>
                <h3 style={modalS.title}>Mark as Shipped</h3>
                <div style={modalS.sub}>Order YURO-{String(shipModal.orderId).padStart(4, "0")}</div>
              </div>
            </div>

            <div style={modalS.note}>
              A tracking number will be generated automatically once you confirm — no need to enter one.
            </div>

            <div style={modalS.footer}>
              <button style={modalS.cancelBtn} onClick={() => setShipModal(null)}>
                Cancel
              </button>
              <button
                style={{ ...modalS.confirmBtn, ...(savingId === shipModal.orderId ? modalS.confirmBtnDisabled : {}) }}
                disabled={savingId === shipModal.orderId}
                onClick={async () => {
                  const { orderId } = shipModal;
                  await changeStatus(orderId, "SHIPPED");
                  setShipModal(null);
                }}
              >
                {savingId === shipModal.orderId ? "Updating..." : "Confirm Shipped"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Delivery confirmation modal ── */}
      {deliveryModal && (
        <div style={modalS.overlay} onClick={() => { setDeliveryModal(null); setDeliveryImage(null); }}>
          <div style={modalS.box} onClick={(e) => e.stopPropagation()}>
            <div style={modalS.head}>
              <div style={{ ...modalS.iconBox, background: "#f0fdf4" }}>
                <IconUpload />
              </div>
              <div>
                <h3 style={modalS.title}>Confirm Delivery</h3>
                <div style={modalS.sub}>Order YURO-{String(deliveryModal.orderId).padStart(4, "0")}</div>
              </div>
            </div>

            <div style={modalS.note}>
              Please upload an image as proof of delivery to confirm and receive your commission.
            </div>
            
            <input 
              type="file" 
              accept="image/*" 
              style={modalS.fileInput}
              onChange={(e) => setDeliveryImage(e.target.files?.[0] || null)}
            />
            
            {deliveryImage && (
              <img 
                src={URL.createObjectURL(deliveryImage)} 
                alt="Delivery proof preview" 
                style={modalS.imgPreview} 
              />
            )}

            <div style={{ ...modalS.footer, marginTop: 20 }}>
              <button style={modalS.cancelBtn} onClick={() => { setDeliveryModal(null); setDeliveryImage(null); }}>
                Cancel
              </button>
              <button
                style={{ ...modalS.confirmBtn, ...((savingId === deliveryModal.orderId || !deliveryImage) ? modalS.confirmBtnDisabled : {}) }}
                disabled={savingId === deliveryModal.orderId || !deliveryImage}
                onClick={async () => {
                  const { orderId } = deliveryModal;
                  await changeStatus(orderId, "DELIVERED", deliveryImage);
                  setDeliveryModal(null);
                  setDeliveryImage(null);
                }}
              >
                {savingId === deliveryModal.orderId ? "Uploading..." : "Confirm Delivered"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Image preview modal ── */}
      {previewModal && (
        <div style={modalS.overlay} onClick={() => setPreviewModal(null)}>
          <div style={{ ...modalS.box, maxWidth: 500 }} onClick={(e) => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
              <h3 style={modalS.title}>Delivery Proof (Order YURO-{String(previewModal.orderId).padStart(4, "0")})</h3>
              <button
                style={{ background: "none", border: "none", fontSize: 20, cursor: "pointer", color: "#666" }}
                onClick={() => setPreviewModal(null)}
              >
                &times;
              </button>
            </div>
            <div style={{ textAlign: "center" }}>
              <img 
                src={previewModal.imageUrl} 
                alt="Delivery Proof" 
                style={{ maxWidth: "100%", maxHeight: 400, borderRadius: 12, objectFit: "contain", border: "1px solid #eee" }} 
              />
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
              <button style={modalS.cancelBtn} onClick={() => setPreviewModal(null)}>Close</button>
            </div>
          </div>
        </div>
      )}

      {/* ── Toast: shows result of every status change ── */}
      {toast && (
        <div style={{ ...toastS.base, ...(toast.type === "success" ? toastS.success : toastS.error) }}>
          <span style={{ flexShrink: 0, marginTop: 1 }}>
            {toast.type === "success" ? <IconCheckCircle /> : <IconAlertCircle />}
          </span>
          <span>{toast.message}</span>
        </div>
      )}
    </div>
  );
}